import * as yup from "yup";
import moment from "moment";

const isValidObjectWithId = (value) =>
  value &&
  typeof value === "object" &&
  (typeof value.id === "string" || typeof value.id === "number") &&
  value.id !== "";

const today = new Date();
today.setHours(0, 0, 0, 0);

const minDate = new Date();
minDate.setDate(minDate.getDate() - 3);
minDate.setHours(0, 0, 0, 0);

export const validationSchema = yup.object().shape({
  // conceptoFactura: yup
  //   .string()
  //   .required("Ingrese el concepto de la carta porte"),

  fecha: yup
    .date()
    .test("is-valid", "La fecha no puede ser mayor a hoy", (value) =>
      value ? moment(value).isSameOrBefore(moment(), "day") : false
    )
    .test("is-min", "La fecha no puede ser menor a hace 3 días", (value) =>
      value ? moment(value).isSameOrAfter(moment().subtract(3, "days"), "day") : false
    )
    .required("Seleccione una fecha"),

  folio: yup.string().required("Seleccione un folio"),

  serie: yup.string().required("Seleccione una serie"),

  paymentFormId: yup
    .mixed()
    .test("is-selected", "Seleccione una forma de pago", isValidObjectWithId)
    .required("Seleccione una forma de pago"),

  paymentMethodId: yup
    .mixed()
    .test("is-selected", "Seleccione un método de pago", isValidObjectWithId)
    .required("Seleccione un método de pago"),

  customerId: yup
    .mixed()
    .test("is-selected", "Seleccione un cliente", isValidObjectWithId)
    .required("Seleccione un cliente"),

  cfdiId: yup
    .mixed()
    .test("is-selected", "Seleccione un CFDI", isValidObjectWithId)
    .required("Seleccione un CFDI"),

  fiscalRegimeId: yup
    .mixed()
    .test("is-selected", "Seleccione un régimen fiscal", isValidObjectWithId)
    .required("Seleccione un régimen fiscal"),

  // ubicaciones - origen
  fechaHoraSalidaOrigen: yup
    .date()
    .required("Ingrese la fecha y hora de salida de origen"),

  paisOrigen: yup.string().required("Ingrese el país de origen"),
  estadoOrigen: yup
    .mixed()
    .test("is-selected", "Seleccione el estado", isValidObjectWithId)
    .required("Seleccione un estado de origen"),
  codigoPostalOrigen: yup
    .mixed()
    .test("is-selected", "Seleccione un código postal", isValidObjectWithId)
    .required("Seleccione un código postal de origen"),

  calleOrigen: yup.string().required("Ingrese la calle de origen"),

  municipioOrigen: yup
    .mixed()
    .test("is-selected", "Seleccione un municipio", isValidObjectWithId)
    .required("Seleccione un municipio de origen"),

  coloniaOrigen: yup
    .mixed()
    .test("is-selected", "Seleccione una colonia", isValidObjectWithId)
    .required("Seleccione una colonia de origen"),

  // ubicaciones - destino
  fechaHoraLlegadaDestino: yup
    .date()
    .required("Ingrese la fecha y hora de llegada a destino"),

  paisDestino: yup.string().required("Ingrese el país de destino"),
  estadoDestino: yup
    .mixed()
    .test("is-selected", "Seleccione el estado de destino", isValidObjectWithId)
    .required("Seleccione un estado de destino"),
  codigoPostalDestino: yup
    .mixed()
    .test(
      "is-selected",
      "Seleccione un código postal de destino",
      isValidObjectWithId
    )
    .required("Seleccione un código postal de destino"),

  calleDestino: yup.string().required("Ingrese la calle de destino"),

  municipioDestino: yup
    .mixed()
    .test(
      "is-selected",
      "Seleccione un municipio de destino",
      isValidObjectWithId
    )
    .required("Seleccione un municipio de destino"),

  coloniaDestino: yup
    .mixed()
    .test(
      "is-selected",
      "Seleccione una colonia de destino",
      isValidObjectWithId
    )
    .required("Seleccione una colonia de destino"),

  DistanciaRecorrida: yup.string().required("Ingrese la distancia recorrida"),

  conceptosFacturaTabla: yup
    .array()
    .of(
      yup.object().shape({
        cantidad: yup
          .number()
          .required("La cantidad es requerida")
          .typeError("La cantidad debe ser un número")
          .moreThan(0, "La cantidad debe ser mayor a 0"),

        productKey: yup
          .mixed()
          .test(
            "productKey",
            "La clave del producto es requerida",
            isValidObjectWithId
          )
          .required("La clave del producto es requerida"),

        unitKey: yup
          .mixed()
          .test("unitKey", "La unidad es requerida", isValidObjectWithId)
          .required("La unidad es requerida"),

        precioUnitario: yup
          .number()
          .required("El precio unitario es requerido")
          .typeError("El precio unitario debe ser un número")
          .moreThan(0, "El precio unitario debe ser mayor a 0"),

        iva: yup
          .number()
          .typeError("El IVA debe ser un número")
          .min(0, "El IVA no puede ser negativo"),

        total: yup
          .number()
          .required("El total es requerido")
          .typeError("El total debe ser un número")
          .moreThan(0, "El total debe ser mayor a 0"),

        Descripcion: yup
          .string()
          .required("La descripción es requerida"),

        needRetention: yup.boolean(),
        })
    )
    .min(1, "Debes agregar al menos un concepto a la factura"),

  // Mercancías
  mercancias: yup.object().shape({
    PesoBrutoTotal: yup
      .number()
      .typeError("El peso bruto total debe ser un número")
      .required("El peso bruto total es requerido"),
    UnidadPeso: yup.string().required("La unidad de peso es requerida"),
    NumTotalMercancias: yup
      .number()
      .typeError("El número total de mercancías debe ser un número")
      .required("El número total de mercancías es requerido"),
    Mercancia: yup.array().of(
      yup.object().shape({
        BienesTransp: yup
          .mixed()
          .test(
            "is-selected",
            "Seleccione un bien transportado",
            isValidObjectWithId
          )
          .required("Seleccione un bien transportado"),
        Descripcion: yup
          .string()
          .required("La descripción de la mercancía es requerida"),
        Cantidad: yup
          .number()
          .typeError("La cantidad debe ser un número")
          .required("La cantidad es requerida")
          .moreThan(0, "La cantidad debe ser mayor a 0"),
        ClaveUnidad: yup.string().required("La clave de unidad es requerida"),
        PesoEnKg: yup
          .number()
          .typeError("El peso debe ser un número")
          .required("El peso en Kg es requerido")
          .moreThan(0, "El peso debe ser mayor a 0"),
        CantidadTransporta: yup.array().of(
          yup.object().shape({
            Cantidad: yup.string().required("La cantidad es requerida"),
            IDOrigen: yup.string().required("El ID de origen es requerido"),
            IDDestino: yup.string().required("El ID de destino es requerido"),
          })
        ),
      })
    ),
  }),

  // Autotransporte
  PermSCT: yup
    .mixed()
    .test("is-selected", "Seleccione un permiso SCT", isValidObjectWithId)
    .required("Seleccione un permiso SCT"),

  NumPermisoSCT: yup
    .string()
    .trim()
    .required("Ingrese el número de permiso SCT"),

  ConfigVehicular: yup
    .mixed()
    .test(
      "is-selected",
      "Seleccione la configuración vehicular",
      isValidObjectWithId
    )
    .required("Seleccione la configuración vehicular"),

  PesoBrutoVehicular: yup
    .number()
    .typeError("El peso bruto vehicular debe ser un número")
    .positive("El peso debe ser mayor a 0")
    .required("Ingrese el peso bruto vehicular"),

  PlacaVM: yup.string().trim().required("Ingrese la placa del vehículo"),

  AnioModeloVM: yup
    .number()
    .typeError("El año del vehículo debe ser un número")
    .required("Ingrese el año modelo del vehículo")
    .min(1900, "El año no puede ser menor a 1900"),

  AseguraRespCivil: yup
    .object()
    .nullable()
    .shape({
      value: yup.string().required("Seleccione una aseguradora"),
      label: yup.string().required(),
    })
    .required("Seleccione una aseguradora"),

  PolizaRespCivil: yup
    .string()
    .trim()
    .required("Ingrese la póliza de responsabilidad civil"),

  // Figura Transporte
  TipoFigura: yup.string().required("Seleccione el tipo de figura"),
  NombreFigura: yup.string().required("Ingrese el nombre del operador"),
  RFCFigura: yup
    .string()
    .required("Ingrese el RFC del operador")
    .matches(/^([A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3})$/, "Ingrese un RFC válido"),
  NumLicencia: yup.string().required("Ingrese el número de licencia"),
});

export const initialValues = {
  conceptoFactura: "",
  fecha: "",
  folio: "",
  serie: "",
  paymentFormId: null,
  paymentMethodId: null,
  customerId: null,
  cfdiId: null,
  fiscalRegimeId: null,

  // ubicaciones - origen
  fechaHoraSalidaOrigen: "",
  paisOrigen: "MEX",
  estadoOrigen: null,
  codigoPostalOrigen: null,
  calleOrigen: "",
  municipioOrigen: null,
  coloniaOrigen: null,

  // ubicaciones - destino
  fechaHoraLlegadaDestino: "",
  paisDestino: "MEX",
  estadoDestino: null,
  codigoPostalDestino: null,
  calleDestino: "",
  municipioDestino: null,
  coloniaDestino: null,

  DistanciaRecorrida: "",

  // Conceptos
  conceptosFacturaTabla: [],

  //Mercancías
  mercancias: {
    PesoBrutoTotal: "",
    UnidadPeso: "KGM",
    NumTotalMercancias: "",
    Mercancia: [
      {
        BienesTransp: null,
        Descripcion: "",
        Cantidad: "",
        ClaveUnidad: "KGM",
        PesoEnKg: "",
        CantidadTransporta: [
          {
            Cantidad: "",
            IDOrigen: "",
            IDDestino: "",
          },
        ],
      },
    ],
  },

  // Autotransporte
  PermSCT: null,
  NumPermisoSCT: "",
  ConfigVehicular: null,
  PesoBrutoVehicular: "",
  PlacaVM: "",
  AnioModeloVM: "",
  AseguraRespCivil: null,
  PolizaRespCivil: "",

  // Figura Transporte
  TipoFigura: "",
  NombreFigura: "",
  RFCFigura: "",
  NumLicencia: "",
};
